import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['block', 'typeBtn', 'customerBtn', 'legend', 'customerLegend']

  colorByType() {
    this.blockTargets.forEach(block => {
      block.style.backgroundColor = block.dataset.typeColor
    })
    this.typeBtnTarget.className = 'btn btn-primary'
    this.customerBtnTarget.className = 'btn btn-outline-secondary'
    this.legendTarget.style.display = 'flex'
    this.customerLegendTarget.style.display = 'none'
  }

  colorByCustomer() {
    this.blockTargets.forEach(block => {
      block.style.backgroundColor = block.dataset.customerColor
    })
    this.typeBtnTarget.className = 'btn btn-outline-secondary'
    this.customerBtnTarget.className = 'btn btn-primary'
    this.legendTarget.style.display = 'none'
    this.customerLegendTarget.style.display = 'flex'
  }
}
